// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//import router from './router'
import router from './router/index'
import store from './store'
// import VueWechatTitle from 'vue-wechat-title'
// import './assets/css/iconfont.css'
import './assets/css/indexicon.css'
import './assets/css/font-awesome.css'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'mint-ui/lib/style.css'
// import 'jquery/dist/jquery.js'
// import 'bootstrap/dist/js/bootstrap.min.js'
import './assets/css/globle.css'
import $ from 'jquery'

Vue.config.productionTip = false
window.onresize = setHtmlFontSize;

function setHtmlFontSize() {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  const htmlDom = document.getElementsByTagName('html')[0];
  htmlDom.style.fontSize = htmlWidth / 10 + 'px';
};
setHtmlFontSize();
// Vue.use(VueWechatTitle)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // VueWechatTitle,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js